import * as supportedLocales from './locale';
var getDefaultLocal = function (_a) {
    var language = _a.language;
    switch (language) {
        case 'ar':
            return supportedLocales.arSA;
        case 'fr':
            return supportedLocales.frCA;
        case 'es':
            return supportedLocales.esLA;
        case 'he':
            return supportedLocales.heIL;
        default:
            return supportedLocales.enZA;
    }
};
export var getLocaleConfig = function (_a) {
    var country = _a.country, language = _a.language;
    switch (country) {
        case 'AT':
            return language === 'de' ? supportedLocales.deDE : supportedLocales.enDE;
        case 'BR':
            return language === 'pt' ? supportedLocales.ptBR : supportedLocales.enBR;
        case 'CA':
            return language === 'fr' ? supportedLocales.frCA : supportedLocales.enCA;
        case 'CH':
            return language === 'de' ? supportedLocales.deDE : supportedLocales.enDE;
        case 'DE':
            return language === 'de' ? supportedLocales.deDE : supportedLocales.enDE;
        case 'ES':
            return language === 'es' ? supportedLocales.esES : supportedLocales.enES;
        case 'IT':
            return language === 'it' ? supportedLocales.itIT : supportedLocales.enIT;
        case 'JP':
            return language === 'ja' ? supportedLocales.jaJP : supportedLocales.enJP;
        case 'LU':
            return language === 'de' ? supportedLocales.deDE : supportedLocales.enDE;
        case 'LI':
            return language === 'de' ? supportedLocales.deDE : supportedLocales.enDE;
        case 'PT':
            return language === 'pt' ? supportedLocales.ptPT : supportedLocales.enPT;
        case 'US':
            return language === 'es' ? supportedLocales.esLA : supportedLocales.enUS;
        case 'SA':
            return language === 'ar' ? supportedLocales.arSA : supportedLocales.enSA;
        case 'TW':
            return language === 'zh' ? supportedLocales.zhTW : supportedLocales.enTW;
        default:
            return getDefaultLocal({ language: language });
    }
};
//# sourceMappingURL=getLocaleConfig.js.map